import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import AppDetailReflection from "@/views/MGT/AppDetail/AppDetailCom/app-detail-reflection.vue";
import AppDetailPointModal from "@/views/MGT/AppDetail/AppDetailModal/app-detail-point-modal.vue";
import { departmentBindingTree, saveDepartmentUnitMappings } from "@/service/appList.js";
export default {
  name: "UnitReflection",
  components: {
    AppDetailReflection,
    AppDetailPointModal
  },
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      loading: false,
      upstream: "DING_TALK",
      treeData: [],
      retVal: {},
      mappings: []
    };
  },
  mounted() {
    this.getTree();
  },
  computed: {
    isDingding() {
      return this.upstream === "DING_TALK";
    }
  },
  methods: {
    /*
     * 获取所有树
     */
    async getTree() {
      let params = {
        upstream: this.upstream
      };
      this.loading = true;
      let res = await departmentBindingTree(params);
      this.loading = false;
      if (res.data && res.data.result == 0) {
        this.retVal = res.data.retVal;
        this.changeRetVal(res.data.retVal);
        this.recordMap();
      } else {
        this.retVal = {};
        this.treeData = [];
      }
    },
    /*
     * 兼容组件数据处理
     */
    changeRetVal(retVal) {
      let tree = [retVal.virtualRoot];
      let change = (arr, father = null) => {
        arr.forEach(v => {
          // 配置参数设置
          this.setParams(v, father);
          let children = v.children;
          if (children && children.length > 0) {
            change(children, v);
          }
        });
      };
      change(tree);
      this.treeData = tree;
    },
    /*
     * 配置参数设置
     */
    setParams(v, father) {
      // 记录父级
      v.father = father;
      // 左边显示标题
      v.title = v.name;
      // 默认展开
      this.$set(v, "expand", true);
      // 右边是否显示关联功能
      v.bindVisible = v.mutable || !v.mutable && v.bindingNodeType === "UNIT";
      // 可读不可写
      v.disabled = !v.mutable;
      // 右边没有关联时候的标题
      v.bindTitle = $t("at15ll4", "关联单位");
      // 如果是单位bindingNodeType：UNIT为单位关联，如果是部门bindingNodeType：DEPARTMENT，则需要bindingState不等于NULL为部门关联
      v.noBind = v.bindingNodeType !== "UNIT" && v.bindingState === "NULL";
      // 关联的名称
      v.bindName = (() => {
        if (v.bindingNodeType === "UNIT") {
          return `${v.downstream.unitName} (${v.downstream.unitCode})`;
        } else if (v.bindingNodeType === "DEPARTMENT") {
          return `${v.downstream.name} (${v.downstream.code})`;
        }
      })();
    },
    /*
     * 记录已选数据
     */
    recordMap() {
      let change = arr => {
        arr.forEach(v => {
          // 如果已绑定
          if (!v.noBind && v.upstreamDepartmentId) {
            this.mappings.push({
              upstreamDepartmentId: v.upstreamDepartmentId,
              iWorkUnitId: v.downstream.key
            });
          }
          let children = v.children;
          if (children && children.length > 0) {
            change(children);
          }
        });
      };
      change(this.treeData);
    },
    /*
     * 解除关联
     */
    onDeleteBind(rowItem) {
      this.orgSubmit([], rowItem);
    },
    /*
     * 获取对应的数据（单位）
     */
    getTreeData(rowItem) {
      let treeData = [this.retVal.rootUnit];
      let configTree = arr => {
        arr.forEach(v => {
          v.title = v.name || v.unitName;
          this.$set(v, "expand", true);
          // 如果已存在关联单位则默认勾选
          if (!rowItem.noBind && rowItem.downstream.unitCode === v.code) {
            v.webChecked = true;
          } else {
            v.webChecked = false;
          }
          let children = v.children;
          if (children && children.length > 0) {
            configTree(children);
          }
        });
      };
      configTree(treeData);

      // 第一层不可选择
      if (treeData.length > 0) {
        treeData[0].disabled = true;
      }
      return treeData;
    },
    /*
     * 打开映射弹窗
     */
    onOpenBind(item) {
      let treeData = this.getTreeData(item);
      this.$refs.AppDetailPointModal.open(treeData, item);
    },
    /*
     * 关联
     */
    onSubmitBind(data, rowItem) {
      this.orgSubmit(data, rowItem);
    },
    /*
     * 删除当前节点下所有已选中节点
     */
    deleteNodeChildren(rowItem, mappings) {
      let change = arr => {
        arr.forEach(v => {
          if (!v.noBind) {
            let index = mappings.findIndex(m => m.upstreamDepartmentId === v.upstreamDepartmentId);
            if (index > -1) {
              mappings.splice(index, 1);
            }
          }
          let children = v.children;
          if (children && children.length > 0) {
            change(children);
          }
        });
      };
      change(rowItem.children);
    },
    /*
     * 单位提交
     */
    async orgSubmit(data, rowItem) {
      let dataValue = data.length > 0 ? data[0] : {};
      let mappings = JSON.parse(JSON.stringify(this.mappings));
      let {
        uuid = ""
      } = dataValue;
      let obj = {
        upstreamDepartmentId: rowItem.upstreamDepartmentId,
        iWorkUnitId: uuid
      };
      let index = mappings.findIndex(v => v.upstreamDepartmentId === rowItem.upstreamDepartmentId);
      // 如果存在则更新，否则删除
      if (index > -1) {
        if (obj.iWorkUnitId) {
          mappings[index] = obj;
        } else {
          mappings.splice(index, 1);
        }
        // 删除当前节点所有子级的关联
        // this.deleteNodeChildren(rowItem, mappings);
      } else {
        mappings.push(obj);
      }
      let params = {
        session: this.retVal.session,
        upstream: this.upstream,
        mappings
      };
      this.$refs.AppDetailPointModal.setLoading(true);
      let res = await saveDepartmentUnitMappings(params);
      this.$refs.AppDetailPointModal.setLoading(false);
      if (res.data && res.data.result == 0) {
        this.mappings = [];
        if (data.length > 0) {
          this.$Message.success($t("at3ogg4", "关联成功"));
        } else {
          this.$Message.success($t("jk1gy76", "解除关联成功"));
        }
        this.getTree();
        this.$refs.AppDetailPointModal.close();
      }
    }
  }
};